import React, { useMemo, useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
} from "react-bootstrap";
import {
  FaThLarge,
  FaFileAlt,
  FaSun,
  FaMoon,
  FaSignOutAlt,
  FaBars,
  FaColumns,
  FaChartLine,
} from "react-icons/fa";
import { RiGeminiFill } from "react-icons/ri";
import { AiFillDatabase } from "react-icons/ai";
import { NavLink, useNavigate } from "react-router-dom";
import { useTheme } from "./ThemeContext";

function NavMenu() {
  const logo = require("../img/tmis_logo_orig.png");
  const dark_logo = require("../img/tmis_logo_w.png");

  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleThemeToggle = () => {
    toggleTheme();
    document.body.classList.toggle("dark-theme", !isDark);
  };

  const headerClass = useMemo(
    () => (isDark ? "tmis-topbar tmis-topbar--dark" : "tmis-topbar"),
    [isDark]
  );

  const pillWrapperStyle = {
    display: "flex",
    gap: 8,
    padding: 8,
    borderRadius: 14,
    background: isDark ? "transparent" : "rgba(0,0,0,.04)",
  };

  const pillStyle = (active) => ({
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 14px",
    borderRadius: 12,
    fontWeight: 600,
    textDecoration: "none",
    transition: "all .15s ease",
    background: active
      ? "#233b7b"
      : isDark
      ? "transparent"
      : "transparent",
    color: active
      ? "#ffffff"
      : isDark
      ? "#f6f7f8"
      : "#1f2937",
    boxShadow: active
      ? "0 10px 22px rgba(35,59,123,.28)"
      : "none",
  });

  return (
    <>
      <Navbar expand="lg" className={headerClass} sticky="top">
        <Container fluid className="px-3">
          <Navbar.Brand>
            <img
              src={isDark ? dark_logo : logo}
              alt="TMIS Logo"
              style={{ height: 36 }}
            />
          </Navbar.Brand>

          <div className="d-none d-lg-flex align-items-center gap-2 ms-auto">
            <Nav style={pillWrapperStyle}>
              <Nav.Link
                as={NavLink}
                to="/dashboard"
                style={({ isActive }) => pillStyle(isActive)}
              >
                <FaThLarge /> Dashboard
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/enquire"
                style={({ isActive }) => pillStyle(isActive)}
              >
                <FaFileAlt /> Enquiries
              </Nav.Link>

               <Nav.Link
                as={NavLink}
                to="/insights"
                style={({ isActive }) => pillStyle(isActive)}
              >
                <RiGeminiFill  /> Insights
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/analytics"
                style={({ isActive }) => pillStyle(isActive)}
              >
                <FaChartLine /> Data Analytics
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/kanban"
                style={({ isActive }) => pillStyle(isActive)}
              >
                <FaColumns /> Kanban
              </Nav.Link>

               <Nav.Link
                as={NavLink}
                to="/datacenter"
                style={({ isActive }) => pillStyle(isActive)}
              >
                <AiFillDatabase /> Data Center
              </Nav.Link>
            </Nav>

            <Button
              variant="link"
              onClick={handleThemeToggle}
              style={{ color: isDark ? "#fff" : "#111" }}
            >
              {isDark ? <FaMoon /> : <FaSun />}
            </Button>

            <Button
              variant="link"
              onClick={() => navigate("/")}
              style={{ color: "#dc3545" }}
            >
              <FaSignOutAlt />
            </Button>
          </div>

          <div className="d-lg-none ms-auto d-flex gap-2">
            <Button
              variant="link"
              onClick={handleThemeToggle}
              style={{ color: isDark ? "#fff" : "#111" }}
            >
              {isDark ? <FaMoon /> : <FaSun />}
            </Button>

            <Button
              variant="link"
              onClick={() => setShowMenu(true)}
              style={{ color: isDark ? "#fff" : "#111" }}
            >
              <FaBars />
            </Button>
          </div>
        </Container>
      </Navbar>

      <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        placement="end"
        style={{
          background: isDark ? "#111" : "#fff",
          color: isDark ? "#fff" : "#111",
        }}
      >
        <Offcanvas.Header closeButton closeVariant={isDark ? "white" : undefined}>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="flex-column gap-2">
            <Nav.Link as={NavLink} to="/dashboard">Dashboard</Nav.Link>
            <Nav.Link as={NavLink} to="/enquire">Enquiries</Nav.Link>
            <Nav.Link as={NavLink} to="/insights">Insights</Nav.Link>
            <Nav.Link as={NavLink} to="/analytics">Data Analytics</Nav.Link>
            <Nav.Link as={NavLink} to="/kanban">Kanban</Nav.Link>
            <Nav.Link as={NavLink} to="/datacenter">DataCenter</Nav.Link>
           
            <hr />

            <Button
              variant={isDark ? "outline-light" : "outline-dark"}
              onClick={handleThemeToggle}
            >
              {isDark ? "Dark Mode" : "Light Mode"}
            </Button>

            <Button
              variant="outline-danger"
              onClick={() => navigate("/")}
              className="mt-2"
            >
              Logout
            </Button>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default NavMenu;
